<template>
  <div class="bg-skin-secondary" :class="{ 'note-box ': noBox }">
    <div class="minute-note" v-if="getNameButton == 'Editar' && !comment">{{time}}</div>
    <div class="text-area mt-2">
      <textarea
        class="text-area-input disabled:opacity-50"
        name=""
        cols="30"
        rows="10"
        ref="note"
        v-model="note"
        :placeholder="placeholder"
        v-on:keyup.enter="saveNote"
        :disabled="disabled"
      ></textarea>
    </div>
    <div class="actions mt-4">
      <button 
        :disabled="disabled"
        :class="{'opacity-50':disabled}"
        class="cancel cursor-pointer" @click="cancelAction">Cancelar</button>
      <button 
        :disabled="disabled"
        :class="{'opacity-50':disabled}"
        class="save cursor-pointer text-white text-center" @click="saveNote">
        {{ getNameButton }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    showTimer: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: "",
    },
    noBox: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    comment: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      note: "",
      time: 0,
    };
  },
  mounted(){
    this.note = ""
    if (this.GET_EDIT_STATUS && !this.comment) {
      this.note = this.GET_NOTE_SELECTED.content;
      this.time = this.GET_NOTE_SELECTED.time;
    }
    if (this.GET_QUESTION_EDIT && this.comment) 
      this.note = this.GET_QUESTION_SELECTED.questions;

    this.$refs.note.focus();
  },
  computed: {
    ...mapGetters("notes", ["GET_EDIT_STATUS", "GET_NOTE_SELECTED"]),
    ...mapGetters("questions", ["GET_QUESTION_EDIT", "GET_QUESTION_SELECTED"]),
    getNameButton() {
      if ((this.GET_EDIT_STATUS && !this.comment) || (this.GET_QUESTION_EDIT && this.comment)) {
        return "Editar";
      } else {
        return "Guardar";
      }
    },
  },
  methods: {
    saveNote() {
      if(this.note!==''){
        if((this.GET_EDIT_STATUS && !this.comment) || (this.GET_QUESTION_EDIT && this.comment))
          this.editNote()
        else 
          this.$emit("saveNote", this.note);

        this.note = "";
        this.$emit("change");
      }
    },
    editNote() {
      if(!this.comment){
        let body = {
          id: this.GET_NOTE_SELECTED.id,
          content: this.note,
          time: this.GET_NOTE_SELECTED.time,
        };
        this.$store.dispatch("notes/edit_notes_course", {
          _body: body,
        });
        this.$store.commit("notes/SET_NOTE_EDIT", false);
      }
      else{
        let body = {
          id: this.GET_QUESTION_SELECTED.id,
          content: this.note,
          mounted_course_id: this.GET_QUESTION_SELECTED.mounted_courses_id,
        };
        this.$store.dispatch("questions/put_questions_course", {
          _body: body,
        });
        this.$store.commit("questions/SET_QUESTION_EDIT", false);

      }
    },
    cancelAction() {
      if(this.noBox && !this.comment){
        this.$store.commit("notes/SET_NOTE_EDIT", false);
        this.$emit("change");
      }else if(this.noBox && this.comment){
        this.$store.commit("questions/SET_QUESTION_EDIT", false);
        this.$emit("change");
      }else{
        this.$emit("cancel");
      }
    },
  },
};
</script>

<style scoped>
.minute-note {
  text-align: right;
  font: normal normal normal 12px/14px Roboto;
  letter-spacing: 0px;
  color: #65676b;
  opacity: 1;
}

.save {
  background: #c6c6c6 ;
  border-radius: 13px;
  padding: 2px 10px;
  font-size: 13px;
  margin-left: 20px;
  transition: all 0.5s;
  outline: none;
}
.save:hover {
  background: #db2777;
}

.cancel {
  outline: none;
  font-size: 13px;
  color: #c6c6c6;
  transition: all 0.5s;
}
.cancel:hover {
  color: #f28062;
}

.actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.note-box {
  width: 100%;
  height: auto;
  box-shadow: 1px 2px 5px #00000029;
  border-radius: 7px;
  opacity: 1;
  padding: 17px 13px 13px 17px;
  margin-top: 20px;
}

.text-area-input {
  height: 55px;
  width: 100%;
  background: #f8f8f8 0% 0% no-repeat padding-box;
  border-radius: 5px;
  resize: none;
  padding: 10px;
  font: normal normal normal 13px/18px Roboto;
  outline: none;
}
</style>
